import axios from 'axios';
import { Common } from '../common';
import {
  ComponentsJsonResponseWithCompactStr,
  LabelboxDataRowBody,
} from '../models/predict/vision';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getRecognizedComponents(
    gsPath: string,
    version?: string,
    ehrInstance?: string,
  ): Promise<ComponentsJsonResponseWithCompactStr> {
    const url = this.common.constructPath(`/predict/vision/ui/components`, {
      gsPath,
      version,
      ehrInstance,
    });
    return await this.common.getJSON(url);
  }

  async getMultistageModelVersions(): Promise<string[]> {
    const url = this.common.constructPath(
      '/predict/vision/ui/multistage/versions',
    );
    const { versions } = await this.common.getJSON(url);
    return versions;
  }

  async getSignedUploadUrlPredict(
    folder: string,
    dataId: string,
  ): Promise<{ signedUploadUrl: string; fullGsPath: string }> {
    const url = this.common.constructPath(`/predict/vision/signed-upload-url`, {
      folder,
      dataId,
    });
    return await this.common.getJSON(url);
  }

  async ocrWithGoogle(gsPath: string): Promise<string[]> {
    const url = this.common.constructPath(`/predict/vision/ocr/gcloud`, {
      gsPath,
    });
    const { texts } = await this.common.getJSON(url);
    return texts;
  }

  async upload(
    file: Blob,
    signedUploadURL: string,
    contentType: string = 'image/png',
  ): Promise<number> {
    const response = await axios.put(signedUploadURL, file, {
      headers: {
        'Content-Type': contentType,
      },
      timeout: 30000,
    });
    return response.status;
  }

  async createLabelboxDataRow(
    datasetId: string,
    body: LabelboxDataRowBody,
  ): Promise<number> {
    const url = this.common.constructPath(
      `/predict/vision/labelbox/${datasetId}/create-data-row`,
    );
    const { status } = await this.common.postJSON(url, body);
    return status;
  }
}
